import { projectSelectors } from '../../../../store/modules/project';
import { uploadsActions, uploadsSelectors } from '@anm/store/modules/uploads';
import useProgressListener from '@anm/store/modules/uploads/hooks/useProgressListener';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userSelectors } from '../../../../store/modules/user';

import routes from '../../../../routes';
import { videoFolderActions, videoFolderSelectors } from '../../../../store/modules/videoFolder';

const { Router } = routes;

type HookProps = {
  projectId: string;
  canCheck?: boolean;
};

const useUploadCheck = ({ canCheck = true, projectId }: HookProps) => {
  const [isUploadExists, setIsUploadExists] = useState(false);

  const listener = useProgressListener();

  const dispatch = useDispatch();
  const user = useSelector(userSelectors.selectUser);
  const hostingStats = useSelector(userSelectors.selectUserHostingStats)?.data || null;
  const createdUpload = useSelector(uploadsSelectors.selectLatestUpload);
  const currentProject = useSelector(state => videoFolderSelectors.selectProjectById(state, projectId));
  const fetchedProject = useSelector(projectSelectors.selectCurrentProject);
  const uploadError = useSelector(uploadsSelectors.selectUploadError);
  const project = currentProject || fetchedProject;

  useEffect(() => {
    const isPermissionError = uploadError?.code === 400;

    isPermissionError && Router.pushRoute('404');
  }, [uploadError?.code]);

  const createVideo = () => {
    dispatch(
      uploadsActions.createUpload({
        id: projectId,
        hostingStats,
        canIgnoreStorage: true,
        createHost: true,
        user: user.profile,
        isUploadFile: false,
        progressListener: listener,
        uploads: [
          {
            id: projectId
          }
        ]
      })
    );
  };

  useEffect(() => {
    if (!createdUpload?.hostId) return;

    setIsUploadExists(true);

    return () => {
      dispatch(videoFolderActions.updateProjectHostingId({ hostId: createdUpload.hostId!, projectId }));
      dispatch(uploadsActions.clearUploadedFiles());
    };
  }, [createdUpload?.hostId]);

  useEffect(() => {
    if (!project || !canCheck) return;

    const { hostingId } = project.extra;

    hostingId ? setIsUploadExists(true) : createVideo();
  }, [project?.id, canCheck]);

  return [currentProject, isUploadExists] as const;
};

export default useUploadCheck;
